<template>
  <Modal
    v-model="_value"
    width="500"
    title="增加设备维修记录"
    @on-visible-change="visibleChange"
    ok-text="确认"
    @on-ok="onOk">
    <div style="position:relative;">
      <Form ref="maintainDeviceRecordRef" :model="maintainDeviceRecord" :label-width="80">
        <FormItem prop="content" label="主机号" style="width: 220px;">
          <Select v-model="selectDevice" @on-change="selectTerminalNum">
            <Option v-for="item in devices" :value="item" :key="item.terminalNum">{{item.terminalNum}}</Option>
          </Select>
        </FormItem>
        <FormItem label="操作">
          <Checkbox v-model="maintainDeviceRecord.changeDevice"><span>更换主机</span></Checkbox>
          <Checkbox v-model="maintainDeviceRecord.changeFitting"><span>更换配件</span></Checkbox>
          <Checkbox v-model="maintainDeviceRecord.changeSim"><span>更换SIM卡</span></Checkbox>
          <Checkbox :disabled="maintainDeviceRecord.changeDevice || maintainDeviceRecord.changeSim"
                    v-model="maintainDeviceRecord.removeDevice"><span>拆除设备</span></Checkbox>
        </FormItem>
        <FormItem v-if="maintainDeviceRecord.changeSim" prop="newTerminalNum" label="新设备卡号（11位）">
          <Input v-model="maintainDeviceRecord.newTerminalNum"></Input>
          <span v-if="maintainDeviceRecord.changeSim && maintainDeviceRecord.newTerminalNum == null || maintainDeviceRecord.newTerminalNum == ''" style="color: red">不能为空</span>
        </FormItem>
        <FormItem v-if="maintainDeviceRecord.changeSim" prop="newTerminalNum" label="修改主机号">
          <Checkbox v-model="maintainDeviceRecord.changeTerminalNum"><span>设备是否使用新主机号</span></Checkbox><br>
          <span style="color: red">视频机默认不修改，部标机根据情况自行勾选（默认需要修改）</span>
        </FormItem>
        <FormItem v-if="maintainDeviceRecord.changeDevice" prop="newFactoryTerminalNum" label="新设备出厂主机号">
          <Input v-model="maintainDeviceRecord.newFactoryTerminalNum"></Input>
          <span v-if="maintainDeviceRecord.changeDevice && maintainDeviceRecord.newFactoryTerminalNum == null || maintainDeviceRecord.newFactoryTerminalNum == ''" style="color: red">不能为空</span>
        </FormItem>
        <FormItem v-if="maintainDeviceRecord.changeDevice" prop="newEncryptionchipnumber" label="设备芯片码">
          <Input v-model="maintainDeviceRecord.newEncryptionchipnumber"></Input>
          <span v-if="maintainDeviceRecord.changeDevice && maintainDeviceRecord.newEncryptionchipnumber == null || maintainDeviceRecord.newEncryptionchipnumber == ''" style="color: red">不能为空</span>
        </FormItem>
        <FormItem v-if="maintainDeviceRecord.changeDevice" prop="newPositioningDeviceModelId" label="新设备型号">
<!--          <Input v-model="maintainDeviceRecord.newPositioningDeviceModelId"></Input>-->
          <Select v-model="maintainDeviceRecord.newPositioningDeviceModelId">
            <Option v-for="(option, index) in positioningDeviceModelOptions" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
          </Select>
          <span v-if="maintainDeviceRecord.changeDevice && maintainDeviceRecord.newPositioningDeviceModelId == null || maintainDeviceRecord.newPositioningDeviceModelId == ''" style="color: red">不能为空</span>
        </FormItem>
        <FormItem v-if="maintainDeviceRecord.removeDevice" prop="newFactoryTerminalNum">
          <Checkbox v-model="maintainDeviceRecord.deviceRecycle"><span>拆除设备是否可使用</span></Checkbox>
        </FormItem>

        <FormItem v-if="maintainDeviceRecord.changeFitting" prop="newFactoryTerminalNum">
          <Button type="primary" style="margin-right: 3px;" size="small" @click="addFittingList">增加</Button>
          <div v-for="(item, index) in fittingList">

            <div>
              <Row>
                <Col span="14">
                  <Select v-model="item.PositioningDeviceFittingFirstOrderType" @on-change="omChangeFitting(index)">
                    <Option v-for="(option, index2) in positioningDeviceModelOptions" :value="option" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
                  </Select>
                </Col>
                <Col span="4">
                  <InputNumber :min="0" style="width: 100%;" v-model="item.fittingListItemNum" @on-change="omChangeFitting(index)"
                               placeholder="请输入配件数量">
                  </InputNumber>
                </Col>
                <Col span="4">
                  <InputNumber :min="0" style="width: 100%;" v-model="item.totalAmount" readonly="true"
                               placeholder="总金额">
                  </InputNumber>
                </Col>
                <Col span="2">
          <Button type="primary" style="margin-right: 3px;" size="small" @click="deleteFittingList(index)">删除</Button>
                </Col>
              </Row>
            </div>

          </div>

        </FormItem>

      </Form>
      <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="dataLoading">
        <Spin size="large"></Spin>
        <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
      </div>
    </div>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'maintainorderaddmaintaindevicerecordmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      devices: [],
      selectDevice: null,
      dataLoading: false,

      positioningDeviceModelOptions: [
        { name: 'BSJ-A6-BD', val: 1 },
        { name: 'BSJ-GF03', val: 2 },
        { name: 'BSJ-M11', val: 3 },
        { name: 'K5', val: 4 },
        { name: 'D5X', val: 5 },
        { name: 'G-3G', val: 6 },
        { name: 'D5X-HDD', val: 7 },
        { name: 'D5X-XR', val: 8 },
        { name: 'BSJ-GF06', val: 9 },
        { name: 'BSJ-RM01', val: 10 },
        { name: 'HIK-A3', val: 11 },
        { name: 'HIK-A3L', val: 12 },
        { name: 'BSJ-A6L', val: 13 },
        { name: 'BSJ-A7', val: 14 }
      ],

      maintainDeviceRecord: {
        terminalNum: null,
        newTerminalNum: null,
        newFactoryTerminalNum: null,
        newEncryptionchipnumber: null,
        newPositioningDeviceModel: null,
        newPositioningDeviceModelId: null,
        changeDevice: false,
        changeFitting: false,
        changeSim: false,
        changeTerminalNum: false,
        removeDevice: false,
        deviceRecycle: false,
        positioningDeviceInfoId: null,
        positioningDeviceInfo: null,
        result: null,
        maintainOrderId: null
      },

      fittingList: [],
      PositioningDeviceFittingFirstOrderType: {
        name: null,
        talAmount: null
      },
      fittingListItemNum: null,
      talAmount: null
    }
  },
  methods: {
    ...mapActions([
      'MaintainOrderServ_AddMaintainDeviceRecord'
    ]),
    addFittingList () {
      this.fittingList.push({
        PositioningDeviceFittingFirstOrderType: this.PositioningDeviceFittingFirstOrderType,
        fittingListItemNum: this.fittingListItemNum,
        talAmount: this.talAmount
      })
      console.log(this.fittingList)
    },
    deleteFittingList (index) {
      console.log(index)
      this.fittingList.splice(index, 1)
      console.log(this.fittingList)
    },
    omChangeFitting (index) {
      console.log(index)
      console.log(
        this.fittingList[index]
      )
      this.fittingList[index].talAmount = this.fittingList[index].PositioningDeviceFittingFirstOrderType.talAmount * this.fittingList[index].fittingListItemNum
    },
    selectTerminalNum (e) {
      console.log(e)
      if (e.positioningDeviceModel.adas) {
        this.maintainDeviceRecord.changeTerminalNum = false
      } else {
        this.maintainDeviceRecord.changeTerminalNum = true
      }
    },
    onOk () {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认添加</p>',
        onOk: () => {
          this.maintainDeviceRecord.terminalNum = this.selectDevice.terminalNum
          if (this.maintainDeviceRecord.terminalNum.changeDevice || this.maintainDeviceRecord.terminalNum.changeSim) {
            this.maintainDeviceRecord.terminalNum.deviceRecycle = false
          }
          // console.log(this.maintainDeviceRecord)
          store.dispatch('MaintainOrderServ_AddMaintainDeviceRecord', {
            params: this.maintainDeviceRecord
          }).then(() => {
            store.dispatch('', {
              params: {
                maintaindevicerecordfittinglist: this.fittingList
              }
            }).then(() => {

            }).catch(err => {
              console.log(err)
            })
            this.$Message.success('添加成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {

        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.selectDevice = null
        this.maintainDeviceRecord.maintainOrderId = this._initValue
        store.dispatch('MaintainOrderServ_GetCanMakeRecordDevices', {
          params: { id: this._initValue },
          urlparams: null
        }).then(() => {
          let devices = store.getters.get_MaintainOrder_GetCanMakeRecordDevicesResult
          console.log(devices)
          if (devices) {
            this.devices = devices
          }
        }).catch(err => {
          this.$Message.error(err)
        })
        store.dispatch('PositioningDeviceTypeServ_GetAll', {
          params: {},
          urlparams: null
        }).then(() => {
          this.positioningDeviceModelOptions = store.getters.get_PositioningDeviceType_GetAllResult
        }).catch(err => {
          console.log(err)
        })
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
